// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PoDetail } from './po-detail';
import { PoHeader } from './po-header';
import { PoNoteType } from './po-note-type';
import { PoTrx } from './po-trx';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoNote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit?: string;
  /** Boolean */
  isIssue!: boolean;
  /** DateTimeOffset */
  modTs!: Date;
  /** String(4) */
  modUserInit?: string;
  /** String */
  note?: string;
  /** Int32 FK poDetail */
  poDetailId?: number;
  /** Int32 FK poHeader */
  poHeaderId?: number;
  /** String(15) FK poNoteType */
  poNoteTypeId!: string;
  /** Int32 FK poTrx */
  poTrxId?: number;
  /** Binary */
  rowVersion!: any;
  /** FK poDetailId */
  poDetail!: PoDetail;
  /** FK poHeaderId */
  poHeader!: PoHeader;
  /** FK poNoteTypeId */
  poNoteType!: PoNoteType;
  /** FK poTrxId */
  poTrx!: PoTrx;
}

